<template>
  <div>
    <!-- breadcrumb -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>机器人</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- search -->
    <el-form :inline="true" :model="queryForm" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="queryForm.robotId" placeholder="机器人ID" clearable
          style="width: 160px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="queryForm.remark" placeholder="备注" clearable style="width: 160px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh" @click="onReset">重置</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="showInsertDialog">新增</el-button>
      </el-form-item>
    </el-form>

    <!--list-->
    <el-table size="small" :data="tableData" highlight-current-row v-loading="loading" border
      element-loading-text="loading" style="width: 100%;">
      <el-table-column prop="robotId" label="机器人ID" width="220">
      </el-table-column>
      <el-table-column prop="nickName" label="昵称" width="100">
      </el-table-column>
      <el-table-column prop="wxid" label="微信ID" width="150">
      </el-table-column>
      <el-table-column prop="online" label="在线状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.online ? 'success' : 'danger'" size="small">
            {{ scope.row.online ? '在线' : '离线' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
          <i class="el-icon-edit remark-edit-icon" @click="showRemarkDialog(scope.row)"></i>
        </template>
      </el-table-column>
      <el-table-column prop="callbackUrl" label="回调URL" width="220" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="160">
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.updateTime) }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="操作" min-width="80">
        <template slot-scope="scope">
          <el-button type="text" size="mini" icon="el-icon-delete" style="color: #F56C6C;"
            @click="deleteRobot(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- page -->
    <Pagination v-bind:child-msg="pageParam" @callback_getPageData="callback_getPageData"></Pagination>

    <!-- 新增对话框 -->
    <el-dialog title="新增机器人" :visible.sync="insertDialogVisible" width="400px">
      <el-form :model="insertForm" :rules="insertRules" ref="insertForm" label-width="120px">
        <el-form-item label="机器人ID" prop="robotId">
          <el-input v-model="insertForm.robotId" placeholder="请输入机器人ID" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input size="small" v-model="insertForm.remark" placeholder="请输入备注" type="textarea" :rows="3" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="insertDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitInsert">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑备注对话框 -->
    <el-dialog title="编辑备注" :visible.sync="remarkDialogVisible" width="400px">
      <el-form :model="remarkForm" ref="remarkForm" label-width="120px">
        <el-form-item label="机器人ID">
          <el-input v-model="remarkForm.robotId" disabled></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="remarkForm.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="remarkDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitRemark">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { robotPage, robotInsert, robotUpdate, robotDelete } from '../../api/robot'
import Pagination from '../../components/Pagination'
import { loadToken } from '../../utils/util'

export default {
  name: 'Robot',
  data() {
    return {
      loading: false,
      submitLoading: false,
      tableData: [],
      queryForm: {
        current: 1,
        size: 10,
        robotId: undefined,
        remark: undefined,
        token: loadToken()
      },
      // page param
      pageParam: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 新增对话框
      insertDialogVisible: false,
      insertForm: {
        robotId: '',
        remark: ''
      },
      insertRules: {
        robotId: [
          { required: true, message: '请输入机器人ID', trigger: 'blur' }
        ],
        remark: [
          { max: 255, message: '备注长度不超过 255 个字符', trigger: 'blur' }
        ],
      },
      // 编辑备注对话框
      remarkDialogVisible: false,
      remarkForm: {
        robotId: '',
        remark: ''
      }
    }
  },
  components: {
    Pagination
  },
  created() {
    this.getPageData()
  },
  methods: {
    // 加载分页数据
    getPageData(parameter) {
      this.loading = true
      if (!parameter) {
        parameter = this.queryForm
      }
      robotPage(parameter)
        .then(res => {
          this.loading = false
          this.tableData = res.data.records
          this.pageParam.currentPage = res.data.current
          this.pageParam.pageSize = res.data.size
          this.pageParam.total = res.data.total
        })
        .catch(err => {
          this.loading = false
          console.error('获取数据失败:', err)
          this.$message({
            type: 'error',
            message: '获取数据失败，请检查网络连接或稍后重试'
          })
        })
    },
    // 分页回调
    callback_getPageData(parm) {
      this.queryForm.current = parm.currentPage
      this.queryForm.size = parm.pageSize
      this.getPageData()
    },
    // 搜索
    onSearch() {
      this.queryForm.current = 1
      this.getPageData()
    },
    // 重置
    onReset() {
      this.queryForm.robotId = undefined
      this.queryForm.remark = undefined
    },
    // 格式化日期时间
    formatDateTime(dateTime) {
      if (!dateTime) return ''
      return dateTime.replace('T', ' ')
    },
    // 显示新增对话框
    showInsertDialog() {
      this.insertForm = {
        robotId: '',
        remark: ''
      }
      this.insertDialogVisible = true
    },
    // 提交新增
    submitInsert() {
      this.$refs.insertForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          robotInsert(this.insertForm)
            .then(res => {
              this.submitLoading = false
              this.$message({ type: 'success', message: '新增成功' })
              this.insertDialogVisible = false
              this.getPageData()
            })
            .catch(err => {
              this.submitLoading = false
              console.error('新增失败:', err)
            })
        }
      })
    },
    // 删除机器人
    deleteRobot(row) {
      this.$confirm('确定删除机器人[' + row.robotId + ']吗？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        robotDelete({ idList: [row.robotId] })
          .then(res => {
            this.$message({ type: 'success', message: '删除成功' })
            this.getPageData()
          })
          .catch(err => {
            this.$message({ type: 'error', message: '删除失败' })
            console.error(err)
          })
      }).catch(() => { })
    },
    // 显示编辑备注对话框
    showRemarkDialog(row) {
      this.remarkForm = {
        robotId: row.robotId,
        remark: row.remark || ''
      }
      this.remarkDialogVisible = true
    },
    // 提交备注修改
    submitRemark() {
      this.submitLoading = true
      robotUpdate(this.remarkForm)
        .then(res => {
          this.submitLoading = false
          this.$message({ type: 'success', message: '修改成功' })
          this.remarkDialogVisible = false
          this.getPageData()
        })
        .catch(err => {
          this.submitLoading = false
          this.$message({ type: 'error', message: '修改失败' })
          console.error(err)
        })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.user-search .el-input--small {
  width: 180px !important;
}

.remark-edit-icon {
  margin-left: 8px;
  color: #409EFF;
  cursor: pointer;
}

.remark-edit-icon:hover {
  color: #66b1ff;
}

.el-button--text {
  padding: 0 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/robot/robot.vue